// Angular imports
import { Injectable } from '@angular/core';

// Model imports
import { IDynamicDashboardWidgetsFactory } from '../../dashboard-module/_interfaces/dynamic-dashboard-widgets-factory';
import { DynamicDashboardWidget } from '../../dashboard-module/_model/dynamic-dashboard-widget';

// Component imports
import { SearchComponent } from '../../search/search.component';
import { WorkflowDashboardComponent } from '../../workflow/components/workflow-dashboard/workflow-dashboard.component';
import { UserDashboardWidgetComponent } from '../../shared-widgets-module/widgets/user-dashboard-widget/user-dashboard-widget.component';
import { UserCommunitiesComponent } from '../../user-portfolio-module/user-communities/user-communities.component';
import { BoardApprovalComponent } from '../../board-approval/component/board-approval/board-approval.component';

// Service imports
import { CiraHelpService } from '../shared-services/cira-help.service';

// Constant imports
import { CiraHelpKeyConstants } from '../../_constants/cira-help-key-constants';

@Injectable()
export class WidgetsFactoryService implements IDynamicDashboardWidgetsFactory {
    private readonly _dashboardWidgets: DynamicDashboardWidget[];

    constructor(private readonly ciraHelp: CiraHelpService) {
        const helpLink = this.ciraHelp.getHelpLinkByKey(CiraHelpKeyConstants.userDashboardWidget);
        this._dashboardWidgets = [
            new DynamicDashboardWidget('search-component', 'ADVANCE_SEARCH', 'Search', SearchComponent, true, true),
            new DynamicDashboardWidget(
                'board-approvals',
                'PORTFOLIO_BOARD_APPROVALS',
                'Board Approvals',
                BoardApprovalComponent,
                true,
                true
            ),
            new DynamicDashboardWidget(
                'workflow-dashboard',
                'WORKQUEUE',
                'AAP Workflow Dashboard',
                WorkflowDashboardComponent,
                true,
                true
            ),
            new DynamicDashboardWidget(
                'user-dashboard',
                'HOME',
                'Open Work',
                UserDashboardWidgetComponent,
                false,
                true,
                helpLink
            ),
            new DynamicDashboardWidget(
                'team-dashboard',
                'HOME',
                'Team Open Work',
                UserDashboardWidgetComponent,
                false,
                true,
                helpLink
            ),
            new DynamicDashboardWidget(
                'my-communities',
                'MY_COMMUNITIES',
                'My Communities',
                UserCommunitiesComponent,
                true,
                true,
                helpLink
            )
        ];
    }

    getDashboardWidgets(): DynamicDashboardWidget[] {
        return this._dashboardWidgets;
    }
}
